<!-- =========================================================================================
  File Name: Announcenment.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
        <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />
    <div>
    <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Announcement</vs-button>
  </div>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search
              :data="data">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ data.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : data.length }} of {{ queriedCamUsers }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>


      <template slot="thead">
        <vs-th >Message</vs-th>
        <vs-th>Location</vs-th>
        <vs-th>Role</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Expiry Date</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>

        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="cursor-auto">{{ tr.message }}</p>
          </vs-td>

          <vs-td>
              <!-- <div :key="index" v-for="(location, index) in tr.locations">
                 <vs-chip >{{location.name}}</vs-chip>
                </div> -->

            <vs-chip  class="product-name font-medium truncate" :key="index" v-for="(location, index) in tr.locations">{{location.name }}</vs-chip><br>
          </vs-td>
          <vs-td>
            <vs-chip class="product-name font-medium truncate" :key="index" v-for="(role, index) in tr.roles">{{role.name }}</vs-chip>

          </vs-td>
          <vs-td>
            <p  class="product-name font-medium truncate">  {{ tr.created_at | formatDates }}</p>
          </vs-td>
           <vs-td>
            <p  class="product-name font-medium truncate">  {{ tr.status }}</p>
          </vs-td>
          <vs-td>
            <p  class="product-name font-medium truncate">  {{ tr.expiry_date | formatDate }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>
                <vs-dropdown-menu>
                <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                <span> Edit </span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr.id)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>


        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    
  </div>
</template>

<script>

import 'flatpickr/dist/flatpickr.css'
import DataViewSidebar from './DataViewSidebar.vue'
import {ALL_ANNOUNCEMENTS, REMOVE_ANNOUNCEMENT } from '@/graphql'
import moment from 'moment'


export default {
  components: {
    DataViewSidebar
  },
  filters: {
    formatDates (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
      }
    },
    formatDate (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY')
      }
    }

  },
  data () {
    return {

      data:[],

      itemsPerPage: 4,
      isMounted: false,
      activeLoading:false,
      addNewDataSidebar: false,
      sidebarData: {},
      DeleteItem:''

    }
  },
  computed: {

    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    select () {
      return this.selected.length
    },
    queriedCamUsers () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    }
  },
  methods: {
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    confirmDeleteRecord (id) {
      this.DeleteItem = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'You are about to permanently delete',
        accept: this.deleteRecord,
        acceptText: 'Delete'

      })
    },
    StatusSuccess (msg) {
      this.get()
      this.$vs.notify({
        title: 'Announcement',
        text:  msg,
        color: 'success',
        position: 'top-right'
      })
    },
    deleteRecord () {
      this.$apollo
        .mutate({
          mutation: REMOVE_ANNOUNCEMENT,
          variables: {
            id: this.DeleteItem
          }
        })
        .then(response => {
          if (response.data.deleteAnnouncement.status === 'Success') {
            this.StatusSuccess(response.data.deleteAnnouncement.message)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_ANNOUNCEMENTS
        })
        .then(response => {
          this.activeLoading = false
          this.$vs.loading.close()
          this.data = response.data.announcements
        })

    }
  },
  created () {
    this.get()
  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type:'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
